import component from './index.vue';

export default {
	install(Vue){
		Vue.component('Upload', component);
	}
}
